var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownFarma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000056410487971486217380000005758179286388384915_);fill:#FFFFFF;}\r\n\t\r\n\t\t.st1{clip-path:url(#SVGID_00000056410487971486217380000005758179286388384915_);fill:#FFFFFF;stroke:#7EBBC5;stroke-width:7.5;stroke-linecap:round;stroke-linejoin:round;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 200,
    height: 200
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041977882483631838170000016238332568454403741_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000041977882483631838170000016238332568454403741_)",
      fill: "#FFFFFF"
    },
    d: "M31.84,50.73 c-8.18,0-6.32,5.41-4.92,7.47c1.4,2.06,67.56,88.38,67.56,88.38c1.23,1.81,3.39,2.7,5.6,2.69c2.22,0.01,4.38-0.87,5.6-2.69 c0,0,66.16-86.31,67.56-88.38c1.4-2.06,3.26-7.47-4.92-7.47H31.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000041977882483631838170000016238332568454403741_)",
      fill: "#FFFFFF",
      stroke: "#7EBBC5",
      strokeWidth: 7.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: " M31.84,50.73c-8.18,0-6.32,5.41-4.92,7.47c1.4,2.06,67.56,88.38,67.56,88.38c1.23,1.81,3.39,2.7,5.6,2.69 c2.22,0.01,4.38-0.87,5.6-2.69c0,0,66.16-86.31,67.56-88.38c1.4-2.06,3.26-7.47-4.92-7.47H31.84z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFarma);
export default __webpack_public_path__ + "static/media/arrow_down_farma.dcee565ff6b3f0154a792417d4f22747.svg";
export { ForwardRef as ReactComponent };